import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }, rob) => {
  commit(types.STRUCTURE_ROB_TOGGLE_LOADING);

  axios
    .get(URL_BACKEND + "api-structure/" + rob + "/")
    .then((response) => {
      commit(types.STRUCTURE_ROB_TOGGLE_LOADING);
      commit(types.STRUCTURE_ROB_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.STRUCTURE_ROB_TOGGLE_LOADING);
      commit(types.STRUCTURE_ROB_SET_ERROR, e.message);
    });
};
